<template>
    <div>
        <loading :active.sync="isLoading"
                 :can-cancel="true"
                 :is-full-page="true">

        </loading>
        <h2 v-if="update_orderLocal">Обновление заказа {{ update_orderLocal }} <a @click.prevent="resetOrder()" href="#">новый заказ</a></h2>

        <div class="form-group" v-if="!update_orderLocal">
            <label class="order__input-label">Поиск клиента</label>
            <div class="row">
                <div class="col">
                    <div>по части имени, телефона, eMail</div>
                    <input style="width:unset" class="order__input" v-model="searchTerm" type="text" placeholder="по части имени, телефона, eMail" />
                    <button class="btn btn--blue card4__btn" @click.prevent="searchClient()">Найти</button>
                </div>
                <div class="col valign-middle">
                    <span>найдено: {{ this.foundResult }}</span>
                    <span v-if="this.foundResult > 0"> выберите из списка </span>
                    <div class="form-group">
                        <select class="order__input" v-model="client_idLocal" @change="this.setCurrentUser" v-if="this.foundUsers.length">
                            <option value="0">Новый пользователь</option>
                            <option v-for="(user, key) in this.foundUsers" :value="user.id">{{ user.label }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group" v-if="!update_orderLocal">
            <div class="form-group">
                <div>по номеру заказа (просто поиск, без загрузки заказа)</div>
                <input @change="this.findUserByOrder" class="order__input" name="on_order" v-model="sys_on_orderLocal" placeholder="на основании заказа" />
                <div>{{ this.order_message }}</div>
                <div v-if="this.switch_to > 0">
                    <button class="btn btn--blue card4__btn" @click.prevent="switchToUser()">да</button>
                    <button class="btn btn--red card4__btn" @click.prevent="resetSwitchTo()">нет</button>
                </div>
            </div>
        </div>
        <div v-if="client_idLocal > 0" class="text-success pb-2">
            <div>Заказ будет сделан на имя покупателя с учетной записью {{this.clientLogin}} {{this.clientEmail}}</div>
            <div>Сумма покупок: {{this.clientSumm}}₽</div>
            <div>Действующая скидка:{{this.clientDiscount}}%</div>
            <div v-if="clientCardNumber !==''">
                Выдана дисконтная карта: {{ clientCardNumber }}
            </div>
            <div v-if="this.currentUser.est_discount > this.currentUser.discount">
                Возможная скидка: {{ this.currentUser.est_discount + '%' }}
            </div>
        </div>

        <div class="form-group">
            <label class="order__input-label">Фамилия</label>
            <input @change="setClientData" class="order__input" type="text"  v-model="clientLastName">
        </div>
        <div class="form-group">
            <label class="order__input-label">Имя</label>
            <input @change="setClientData" class="order__input" type="text" v-model="clientFirstName">
        </div>
        <div class="form-group">
            <label class="order__input-label">Email</label>
            <input :disabled="disabled" class="order__input" type="text"  v-model="clientEmail">
        </div>
        <div class="form-group">
            <label class="order__input-label">Контактный телефон</label>
            <masked-input :disabled="disabled" class="order__input"  v-model="clientPhone" mask="\+\7 (111) 111-11-11" placeholder="Контактный телефон" />
        </div>
        <div class="form-group">
            <label class="order__input-label">Входящий номер</label>
            <masked-input class="order__input"  v-model="clientPhoneOrd" mask="\+\7 (111) 111-11-11" placeholder="Входящий номер" />
        </div>
        <div v-if="(this.update_orderLocal == 0) && (this.client_idLocal == 0)">
            <div class="form-group">
                <button type="button" @click.prevent="registerUser" class="btn btn--blue card4__btn">Зарегистрировать как нового пользователя</button>
            </div>
        </div>
        <div v-if="(this.update_orderLocal == 0) && (this.client_idLocal != 0)">
            <button type="button" @click.prevent="resetClient()" class="btn btn--blue card4__btn">Другой покупатель</button>
        </div>
        <div class="text-danger" v-html="message"></div>
    </div>
</template>

<script>
    import MaskedInput from 'vue-masked-input'

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: "cart-register-user",
        components: {
          MaskedInput,
          Loading
        },
        props: {
            client_id: Number,
            update_order: Number,
            sys_on_order: String
        },
        data() {
            return {
                client_idLocal: this.client_id,
                update_orderLocal: this.update_order,
                sys_on_orderLocal: this.sys_on_order,
                searchTerm: '',
                clientFirstName: '',
                clientLastName: '',
                clientLogin: '',
                clientEmail: '',
                clientSumm: '',
                clientDiscount: '',
                clientCardNumber: '',
                clientPhone: '',
                clientPhoneOrd: '',
                currentUser: [],
                foundUsers: [],
                message: '',
                //find_order: '',
                order_message: '',
                switch_to: 0,
            }
        },
        methods: {
            searchClient () {
                this.$store.commit('clearError')
                this.$store.commit('setLoading', true)
                try {
                    let params = new URLSearchParams();
                    params.append('action', 'find_user');
                    params.append('term', this.searchTerm);
                    axios
                        .get('/rest/spec', {params})
                        .then((response) => {

                            let data = JSON.parse(response.data);
                            this.foundUsers = data;
                            this.searchTerm = '';
                            this.$store.commit('setLoading', false)
                        })
                } catch(error) {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error.message)
                    throw error
                }
            },
            refreshUser () {
                this.$store.commit('clearError')
                this.$store.commit('setLoading', true)
                try {
                    let params = new URLSearchParams();
                    params.append('action', 'get_user');
                    params.append('user_id', this.client_idLocal);

                    axios
                        .get('/rest/spec', {params})
                        .then((response) => {

                            this.currentUser = JSON.parse(response.data);
                            this.clientEmail = this.currentUser.email;
                            this.clientLogin = this.currentUser.login;
                            this.clientFirstName = this.currentUser.first_name;
                            this.clientLastName = this.currentUser.last_name;
                            this.clientSumm = this.currentUser.summ;
                            this.clientPhone = '+' + this.currentUser.phone;
                            this.clientCardNumber = this.currentUser.cardnumber;
                            this.clientDiscount = this.currentUser.discount;

                            this.$store.commit('setLoading', false)
                        })
                } catch (error) {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error.message)
                    throw error
                }
            },
            setCurrentUser () {
                if(this.client_idLocal == 0) {
                    return ;
                }
                this.$store.commit('clearError')
                this.$store.commit('setLoading', true)
                try {
                    let params = new URLSearchParams();
                    params.append('action', 'set_client_id');
                    params.append('user_id', this.client_idLocal);

                    axios
                        .put('/rest/spec', params)
                        .then((response) => {
                            // update cart items
                            this.$store.dispatch('setCartItems')

                            this.refreshUser()
                            this.$store.commit('setLoading', false)
                        })
                } catch (error) {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error.message)
                    throw error
                }
            },
            registerUser () {
                let params = new URLSearchParams();
                params.append('action', 'register_user')
                params.append('first_name', (typeof this.clientFirstName!=='undefined') ? this.clientFirstName : '');
                params.append('name', (typeof this.clientLastName !== 'undefined') ? this.clientLastName : '');
                params.append('email', (typeof this.clientEmail !== 'undefined') ? this.clientEmail : '');
                params.append('phone', (typeof this.clientPhone !== 'undefined') ? this.clientPhone : '');
                axios
                    .post('/rest/spec', params)
                    .then((response) => {

                        let data = JSON.parse(response.data)

                        this.message = data.message;
                        if(data.user_id > 0) {
                            this.client_idLocal = data.user_id
                            this.refreshUser()
                        }
                        this.$store.commit('setLoading', false)

                    }).catch(error => {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error.message)
                    throw error
                })
            },
            resetClient () {
                this.client_idLocal = 0;
                this.clientFirstName = '';
                this.clientLastName = '';
                this.clientEmail = '';
                this.clientPhone = '';
                this.sys_on_orderLocal = '';
                this.setOnOrder();
                this.setCurrentUser();
            },
            resetOrder () {
                let params = new URLSearchParams();
                params.append('action', 'unload_order')
                axios
                    .post('/rest/spec', params)
                    .then((response) => {
                        this.update_orderLocal = 0
                        this.$store.commit('setLoading', false)

                    }).catch(error => {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error.message)
                    throw error
                })
            },
            giveoutCard () {
                let params = new URLSearchParams();
                params.append('action', 'grant_card')
                axios
                    .post('/rest/spec', params)
                    .then((response) => {

                        let data = JSON.parse(response.data)

                        this.message = 'выдана карта ' + data.granted_card;
                        // применить скидку к корзине
                        this.applyDiscount()

                        this.$store.commit('setLoading', false)

                    }).catch(error => {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error.message)
                    throw error
                })
            },
            applyDiscount() { // применить скидку к корзине
                let params = new URLSearchParams();
                params.append('action', 'set_card_discount')
                axios
                    .post('/rest/spec', params)
                    .then((response) => {

                        let data = JSON.parse(response.data)

                        this.message = 'выдана карта ' + data.granted_card;
                        // применить скидку к корзине
                        this.applyDiscount()

                        this.$store.commit('setLoading', false)

                    }).catch(error => {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error.message)
                    throw error
                })
            },
            setClientData() {
                if(this.client_idLocal == 0) {
                    return ;
                }
                this.$store.commit('clearError')
                this.$store.commit('setLoading', true)
                try {

                    let params = new URLSearchParams();
                    params.append('action', 'update_user_data');
                    params.append('user_id', this.client_idLocal);
                    params.append('name', this.clientLastName);
                    params.append('first_name', this.clientFirstName);

                    axios
                        .put('/rest/spec', params)
                        .then((response) => {
                            this.refreshUser()
                            this.$store.commit('setLoading', false)
                        })
                } catch (error) {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error.message)
                    throw error
                }
            },
            findUserByOrder()
            {
                this.setOnOrder();

                if(this.sys_on_orderLocal ==='') {
                    this.switch_to = 0;
                    return;
                }

                let params = new URLSearchParams();
                params.append('action', 'find_user_by_order')
                params.append('find_order', this.sys_on_orderLocal)
                params.append('client_id', this.client_idLocal)

                axios
                    .get('/rest/spec', {params})
                    .then((response) => {

                        let data = JSON.parse(response.data)

                        if(data.message !== '') {
                            this.order_message = data.message;
                        }
                        if(data.user_id > 0) {
                            this.switch_to = data.user_id;
                        }

                        this.$store.commit('setLoading', false)
                    }).catch(error => {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error.message)
                    throw error
                })
            },
            switchToUser() {
                this.client_idLocal=this.switch_to;
                this.resetSwitchTo()
                this.setCurrentUser()
            },
            resetSwitchTo() {
                this.switch_to = 0;
                this.order_message = '';
            },
            setOnOrder() {
                let params = new URLSearchParams();
                params.append('action', 'set_on_order')
                params.append('sys_on_order', this.sys_on_orderLocal)

                let param = yii.getCsrfParam();
                let token = yii.getCsrfToken();
                params.append(param, token)

                axios
                    .put('/rest/spec', params)
                    .then((response) => {
                        this.$store.commit('setLoading', false)
                    }).catch(error => {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error.message)
                    throw error
                })
            }
        },
        computed: {
            isLoading() {
                return this.$store.getters.loading;
            },
            disabled() {
                return this.client_idLocal > 0
            },
            foundResult() {
                return (this.foundUsers) ? this.foundUsers.length : 0
            }
        },
        mounted() {
            this.refreshUser()
        }
    }
</script>

<style scoped>

</style>
